/**
 * Builds the `payer` object for POST register payer user DDA (`payers.register`).
 * Must match Payrailz.Api `RegisterPayer` JSON and ZAPIM body for `register payeruserdda`.
 * Do not forward GET payer verbatim — MySQL rejects unknown properties (SpinDataExtractor).
 *
 * @see Payrailz.Api Features/Fsps/RegisterPayer/Models/RegisterPayer.cs
 */

const PAYER_SCALAR_KEYS = [
  'fspPayerId',
  'payerType',
  'serviceStartOn',
  'taxId',
  'limitType',
];

const ORGANIZATION_KEYS = ['name', 'phone', 'email'];

const PERSON_KEYS = [
  'firstName',
  'middleName',
  'lastName',
  'mobilePhone',
  'homePhone',
  'workPhone',
  'email',
];

const USPS_KEYS = ['street1', 'street2', 'city', 'state', 'zip'];

const INTERNATIONAL_KEYS = [
  'address1',
  'address2',
  'address3',
  'address4',
  'locality',
  'adminArea',
  'postalCode',
  'country',
];

const USER_KEYS = [
  'fspUserId',
  'firstName',
  'middleName',
  'lastName',
  'bizRoles',
];

const PAYER_USER_KEYS = [
  'userType',
  'mobilePhone',
  'homePhone',
  'workPhone',
  'email',
  'language',
  'serviceStartOn',
  'limitType',
  'role',
];

const nestedPick = (source, keys) => {
  if (source == null || typeof source !== 'object') {
    return undefined;
  }
  const out = {};
  keys.forEach((k) => {
    if (Object.prototype.hasOwnProperty.call(source, k)) {
      out[k] = source[k];
    }
  });
  return out;
};

/**
 * @param {Record<string, unknown>} payer — typically output of cleanPayer + fsp/tax enrichment
 * @returns {Record<string, unknown>}
 */
const buildRegisterPayerUserDdaPayerPayload = (payer = {}) => {
  const out = {};

  PAYER_SCALAR_KEYS.forEach((k) => {
    if (
      Object.prototype.hasOwnProperty.call(payer, k) &&
      payer[k] !== undefined
    ) {
      out[k] = payer[k];
    }
  });

  if (payer.organization != null && typeof payer.organization === 'object') {
    out.organization = nestedPick(payer.organization, ORGANIZATION_KEYS);
  }
  if (payer.person != null && typeof payer.person === 'object') {
    out.person = nestedPick(payer.person, PERSON_KEYS);
  }
  if (payer.uspsAddress != null && typeof payer.uspsAddress === 'object') {
    out.uspsAddress = nestedPick(payer.uspsAddress, USPS_KEYS);
  }
  if (
    payer.internationalAddress != null &&
    typeof payer.internationalAddress === 'object'
  ) {
    out.internationalAddress = nestedPick(
      payer.internationalAddress,
      INTERNATIONAL_KEYS
    );
  }
  if (payer.user != null && typeof payer.user === 'object') {
    out.user = nestedPick(payer.user, USER_KEYS);
  }
  if (payer.payerUser != null && typeof payer.payerUser === 'object') {
    out.payerUser = nestedPick(payer.payerUser, PAYER_USER_KEYS);
  }

  return out;
};

export default buildRegisterPayerUserDdaPayerPayload;
